import { RouterManager } from '@aclass/admin/managers';
import { NotificationStory } from '@aclass/admin/storage/actions';
import { IAdminState, INotificationModuleState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';

@Injectable()
export class NotificationSearchStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:notification-search';

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<INotificationModuleState['searchPageInitialized']>(['notificationModule', 'searchPageInitialized']).pipe(
            filter(v => v)
        );
        this.employee = this.routerManager.onRejectNavigation(NotificationSearchStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(): void {
        this.ngRdx.dispatch(NotificationStory.dryRunSearchPage());
    }
}
